module.exports = __webpack_public_path__ + "static/img/vip-header-1.16fc41f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/vip-header-1.png
// module id = uaF2
// module chunks = 1